import React, { useState } from "react";
import { AppBtn } from "../../../ui/buttons";
import Modal, { ModalBody, ModalFooter } from "../../../ui/modal-full";
import { DeliveryArea, StoreInterface } from "@/assets/interfaces";
import DataAccordion from "@/components/ui/data-accordion";
import { capitalizeFirstLetter } from "@/assets/js/utils/functions";
import SearchBar from "@/components/ui/search-bar";
import Link from "next/link";
import { useRouter } from "next/router";

interface Props {
  store: StoreInterface;
  show: boolean;
  toggle: (state: boolean) => void;
  paths: { home: string; products: string };
}

const CategoriesModal: React.FC<Props> = ({ store, show, toggle, paths }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const router = useRouter();

  const allCategories = [{ id: "all", name: "All Categories", emoji: "🛍" }, ...store.categories];
  const filteredCategories = allCategories.filter((category) =>
    category.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleCategoryClick = (category: StoreInterface["categories"][number]) => {
    toggle(false);
    router.push(`${paths.products}?category=${category.id}`);
  };

  return (
    <Modal {...{ show, toggle }} fullOnlyOnMobile title="Categories" bgClose={false}>
      <ModalBody className="!pt-0">
        <div className="sticky top-0 py-5 bg-white z-[999] -mb-3.5">
          <SearchBar placeholder="Search categories" {...{ searchQuery, setSearchQuery }} />
        </div>
        <ul className="flex flex-col">
          {filteredCategories.map((category) => (
            <li
              key={category.id}
              className="w-full justify-between border-b border-grey-divider last:border-none cursor-pointer"
            >
              <div
                className="flex items-center justify-between py-3.5 cursor-pointer"
                onClick={() => handleCategoryClick(category)}
              >
                <div className="flex items-center">
                  <figure className="h-7 w-7 bg-primary-500 bg-opacity-10 rounded-full flex items-center justify-center mr-2 text-1xs">
                    {category?.emoji || "🛍"}
                  </figure>
                  <p className="text-sm font-medium text-dark">{capitalizeFirstLetter(category.name)}</p>
                </div>

                <button
                  className={`h-8 w-8 rounded-full flex items-center justify-center bg-grey-fields-100 text-primary-500`}
                  onClick={() => {}}
                  aria-label="next"
                >
                  {/* prettier-ignore */}
                  <svg width="50%" viewBox="0 0 25 25" fill="none">
                  <path d="M5.95703 12.3396H19.957" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M12.957 5.3396L19.957 12.3396L12.957 19.3396" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                </button>
              </div>
            </li>
          ))}
        </ul>
      </ModalBody>
    </Modal>
  );
};

export default CategoriesModal;
